import React, { useState } from "react";

const InteraktScript = () => {
  const isMobile = window.innerWidth <= 768;
  const [isHidden, setIsHidden] = useState(false);

  const handleClick = () => {
    const message =
      "Hi%20Team%20Myprega%21%20%F0%9F%A4%B0%20I%20%E2%80%99m%20curious%20about%20future%20of%20pregnancy%20care.%20Can%20we%20chat%3F";
    const phoneNumber = "919004414624";
    window.open(
      `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`,
      "_blank"
    );
  };

  const handleClose = () => {
    setIsHidden(true);
  };

  if (isMobile && isHidden) {
    return null;
  }

  return (
    <div style={wrapperStyle(isMobile)}>
      {isMobile && (
        <button
          type="button"
          onClick={handleClose}
          style={closeButtonStyle}
          aria-label="Close WhatsApp button"
        >
          x
        </button>
      )}
      <button type="button" onClick={handleClick} style={buttonStyle(isMobile)}>
        <img src="/whatsapp-icon.svg" alt="WhatsApp" style={iconStyle(isMobile)} />
        {!isMobile && "CHAT WITH US"}
      </button>
    </div>
  );
};

const wrapperStyle = (isMobile) => ({
  position: "fixed",
  bottom: isMobile ? "72px" : "17%",
  right: isMobile ? "12px" : "1%",
  zIndex: 999,
});

const buttonStyle = (isMobile) => ({
  background: "linear-gradient(rgb(255, 119, 171) 0%, rgb(255, 0, 134) 100%)",
  color: "white",
  border: "none",
  padding: isMobile ? "0" : "10px 20px",
  cursor: "pointer",
  fontSize: isMobile ? "11px" : "16px",
  borderRadius: isMobile ? "999px" : "30px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
  width: isMobile ? "52px" : "auto",
  height: isMobile ? "52px" : "auto",
  maxWidth: isMobile ? "52px" : "none",
  boxSizing: "border-box",
  boxShadow: "0 10px 22px rgba(255, 0, 134, 0.28)",
});

const iconStyle = (isMobile) => ({
  width: isMobile ? "24px" : "20px",
  height: isMobile ? "24px" : "20px",
});

const closeButtonStyle = {
  position: "absolute",
  top: "-8px",
  right: "-4px",
  width: "20px",
  height: "20px",
  borderRadius: "999px",
  border: "none",
  background: "#2b2b2b",
  color: "#fff",
  fontSize: "12px",
  lineHeight: 1,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.18)",
};

export default InteraktScript;
